var _path, _path2, _rect, _path3, _circle, _path4, _rect2, _line, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotifcations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205.515 176.507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 174.852 174.322 C 188.956 160.218 198.561 142.248 202.452 122.685 C 206.343 103.123 204.346 82.846 196.713 64.418 C 189.08 45.99 176.154 30.24 159.57 19.158 C 142.985 8.077 123.487 2.162 103.541 2.162 C 83.595 2.162 64.097 8.077 47.513 19.158 C 30.928 30.24 18.002 45.99 10.369 64.418 C 2.736 82.846 0.739 103.123 4.63 122.685 C 8.521 142.248 18.126 160.218 32.23 174.322 L 103.541 172.889 L 174.852 174.322 Z",
    fill: "#F7F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 154.582 156.726 C 164.559 146.749 171.353 134.037 174.106 120.199 C 176.859 106.36 175.446 92.016 170.046 78.98 C 164.647 65.944 155.503 54.802 143.771 46.963 C 132.039 39.124 118.246 34.94 104.136 34.94 C 90.026 34.94 76.233 39.124 64.501 46.963 C 52.769 54.802 43.625 65.944 38.225 78.98 C 32.826 92.016 31.413 106.36 34.166 120.199 C 36.918 134.037 43.713 146.749 53.69 156.726 L 104.136 155.713 L 154.582 156.726 Z",
    fill: "#E6E8EE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.919,
    y: 60.389,
    width: 98,
    height: 114,
    rx: 3,
    fill: "white",
    stroke: "#250056",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 96.919 110.875 C 96.064 111.672 95.049 112.305 93.932 112.735 C 92.815 113.168 91.619 113.389 90.409 113.389 C 89.199 113.389 88.003 113.168 86.886 112.735 C 85.769 112.305 84.754 111.672 83.899 110.875",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.021,
    cy: 224.967,
    r: 3,
    fill: "#250056",
    style: {},
    transform: "matrix(1.4097750186920166, 0, 0, 1, -167.5367889404297, -97.02696228027344)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 143.919 80.889 C 143.919 82.822 142.352 84.389 140.419 84.389 C 138.486 84.389 136.919 82.822 136.919 80.889 C 136.919 79.83 137.373 77.847 138.149 76.117 C 138.534 75.26 138.969 74.532 139.413 74.034 C 139.874 73.519 140.216 73.389 140.419 73.389 C 140.622 73.389 140.964 73.519 141.425 74.034 C 141.869 74.532 142.304 75.26 142.689 76.117 C 143.465 77.847 143.919 79.83 143.919 80.889 Z",
    stroke: "#250056",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.919,
    cy: 143.389,
    r: 21,
    fill: "#F7F7FA",
    stroke: "#250056",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 167.609 140.661 C 167.255 137.484 165.934 134.492 163.823 132.091 C 161.713 129.69 158.916 127.995 155.811 127.235 C 152.706 126.476 149.442 126.689 146.462 127.845",
    stroke: "#E6E8EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.325,
    y: 154.409,
    width: 23.696,
    height: 4.519,
    rx: 2.26,
    transform: "matrix(0.7640179991722107, 0.6451950669288635, -0.6451950669288635, 0.7640179991722107, 141.02920532226562, -70.129638671875)",
    stroke: "#250056",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.919,
    y1: 174.389,
    x2: 203.919,
    y2: 174.389,
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.919 46.389 L 48.919 54.389",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 57.919 46.389 L 57.919 52.389",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.919 63.389 L 46.919 63.389",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.919,
    cy: 37.389,
    r: 4,
    stroke: "#9747FF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.419,
    cy: 143.889,
    r: 1.5,
    stroke: "#9747FF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 171.919 102.389 L 175.063 101.834 L 177.115 99.389 L 177.67 102.533 L 180.115 104.585 L 176.972 105.14 L 174.919 107.585 L 174.364 104.442 L 171.919 102.389 Z",
    fill: "#3ADEA2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 80.555 27.753 L 80.924 23.512 L 78.484 20.025 L 82.724 20.395 L 86.212 17.955 L 85.842 22.195 L 88.282 25.682 L 84.042 25.312 L 80.555 27.753 Z",
    fill: "#3ADEA2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 122.157 111.115 C 121.302 111.912 120.287 112.545 119.17 112.975 C 118.053 113.408 116.857 113.629 115.647 113.629 C 114.437 113.629 113.241 113.408 112.124 112.975 C 111.007 112.545 109.992 111.912 109.137 111.115",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifcations);
export default __webpack_public_path__ + "static/media/no-notifcations.4288f6b736336c6299a73d27e05a2247.svg";
export { ForwardRef as ReactComponent };